export const typeOfSexualViolence = [
  {
    key: 'rape',
    value: 'Rape'
  },
  {
    key: 'gang-rape',
    value: 'Gang Rape'
  },
  {
    key: 'sexual-slavery',
    value: 'Sexual Slavery'
  },
  {
    key: 'forced-prostitution',
    value: 'Forced Prostitution'
  },
  {
    key: 'forced-pregnancy',
    value: 'Forced Pregnancy'
  },
  {
    key: 'forced-abortion',
    value: 'Forced Abortion'
  },
  {
    key: 'forced-sterilization',
    value: 'Forced Sterilization'
  },
  {
    key: 'forced-marriage',
    value: 'Forced Marriage'
  },
  {
    key: 'forced-nudity',
    value: 'Forced Nudity'
  },
  {
    key: 'sexual-torture',
    value: 'Sexual Torture'
  },
  {
    key: 'other',
    value: 'other'
  },
];

export const otherFormsOfViolence = [
  {
    key: 'torture',
    value: 'Torture'
  },
  {
    key: 'arbitrary-arrest',
    value: 'Arbitrary arrest'
  },
  {
    key: 'forced-disappearance',
    value: 'Forced Disappearance'
  },
  {
    key: 'imprisonment',
    value: 'Imprisonment'
  },
  {
    key: 'persecution',
    value: 'Persecution'
  },
  {
    key: 'child-recruitment-and-use',
    value: 'Child Recruitment and Use in hostilities'
  }
]

export const violenceDocumentStorage = [
  {
    key: 'TruthAndReconciliationCommission',
    value: 'Truth and Reconciliation Commission'
  },
  {
    key: 'NagarikAawaz',
    value: 'Nagarik Aawaz'
  },
  {
    key: 'NWCSC',
    value: 'NWCSC'
  },
  {
    key: 'CVWSDC',
    value: 'CVWSDC'
  },
  {
    key: 'AnyOtherOrganization',
    value: 'Any Other Organization'
  },
  {
    key: 'OtherGovernmentStructures',
    value: 'Other government structures (Police Department, National Human Rights Commission, National Women\'s Commission)'
  },
  {
    key: 'Other',
    value: 'Other'
  }
]
